import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseEstablishmentBillsProps<T> = {
  filters: {
    search?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    perPage?: number;
    establishmentId?: string
  };
  mapper?: (data: any) => T;
};

const UseEstablishmentBills = <T,>({
  filters: { search, status, startDate, endDate, establishmentId, page = 1 },
  mapper = Mapper.default<T>(),
}: UseEstablishmentBillsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
  data: { data, meta } = defaultTransformerResponse<T>(),
  isPending,
  ...rest } =
    useQuery({
      queryKey: ["establishmentBills", search, status, startDate, endDate, page],
      queryFn: () => {
        return privateAxios.get(`/billing/bills/establishment_bills`, {
          params: {
            search,
            "q[company_id_eq]": establishmentId,
            "q[status_eq]": status,
            "q[opened_at_gteq]": startDate,
            "q[closed_at_lteq]": endDate,
            page: page,
          },
        });
      },
      select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
        return {
          data: mapper(data?.data?.data),
          meta: data?.data?.meta,
        };
      },
      placeholderData: keepPreviousData,
    });

  return { data, meta, isPending, ...rest };
};

export default UseEstablishmentBills;
